/**
 * @module accountsReceivable
 * @description A list of accountsReceivable
 */
export const accountsReceivable = [
	{
		objectNumber: 50002,
		name: 'Sales Revenue',
	},
	{
		objectNumber: 50001,
		name: 'Customer Accounts',
	},
	{
		objectNumber: 50003,
		name: 'Bank Interest Revenue',
	},
]
